import React from "react";
import styles from "./Disclaimer.module.css";

export default function DisclaimerTag(props) {
  const { disclaimerData, type } = props;

  return (
    <div
      className={styles.disclaimer_container}
      style={{ marginTop: `${type === "slide" ? "0px" : "20px"}` }}
    >
      <p
        className={
          disclaimerData && disclaimerData.length > 0 && styles.disclaimer_tag
        }
      >
        {disclaimerData &&
          disclaimerData?.map((item, index) => {
            return <p style={{fontSize:"14px"}}key={index}>{disclaimerData && item?.description}</p>;
            // <div
            //     key={index}
            //     dangerouslySetInnerHTML={{
            //       __html: disclaimerData && item?.description,
            //     }}
            //   />
            
          })}
      </p>
    </div>
  );
}
